import { Component } from 'react';
import * as actions from '../actions';

class RsvpResponseButtons extends Component {
  changeResponse(response, e) {
    e.preventDefault();
    if (!this.props.formSubmitting) {
      actions.toggleRsvpFormVisible(response);
    }
  }

  render() {
    const possibleResponses = window.is_premium ? ['yes', 'no'] : ['yes', 'maybe', 'no'];
    const responses = possibleResponses.map((response) => {
      const rsvpResponse = this.props.rsvpResponse;
      return (
        <li key={response}>
          <a
            href="#"
            onClick={this.changeResponse.bind(this, response)}
            className={'rsvp-button-' + response + (rsvpResponse === response ? ' active' : '')}
          >
            { response }
          </a>
        </li>
      );
    });
    return (
      <ul className="response-buttons-new" >
        { responses }
      </ul>
    );
  }
}

export default RsvpResponseButtons;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/rsvp/components/rsvp-response-buttons.es6